export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST';
export const GET_CUSTOMER_REQUESTING = 'GET_CUSTOMER_REQUESTING';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';

export const GET_CUSTOMER_WITH_DEFAULTS_REQUEST =
  'GET_CUSTOMER_WITH_DEFAULTS_REQUEST';

export const EDIT_CUSTOMER_REQUEST = 'EDIT_CUSTOMER_REQUEST';
export const EDIT_PASSWORD_REQUEST = 'EDIT_PASSWORD_REQUEST';
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_WITH_ADDRESS_REQUEST =
  'ADD_CUSTOMER_WITH_ADDRESS_REQUEST';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const FB_LOGIN_OR_CREATE_REQUEST = 'FB_LOGIN_OR_CREATE_REQUEST';
export const GOOGLE_LOGIN_OR_CREATE_REQUEST = 'GOOGLE_LOGIN_OR_CREATE_REQUEST';
export const LOGIN_REQUESTING = 'LOGIN_REQUESTING';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUESTING = 'LOGOUT_REQUESTING';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const MAGIC_LINK_REQUEST = 'MAGIC_LINK_REQUEST';
export const MAGIC_LINK_REQUESTING = 'MAGIC_LINK_REQUESTING';

export const MAGIC_LINK_ID_REQUEST = 'MAGIC_LINK_ID_REQUEST';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_REQUESTING = 'FORGOT_PASSWORD_REQUESTING';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUESTING = 'RESET_PASSWORD_REQUESTING';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const RESET_PASSWORD_ID_REQUEST = 'RESET_PASSWORD_ID_REQUEST';
export const UNSUBSCRIBE_CUSTOMER_REQUEST = 'UNSUBSCRIBE_CUSTOMER_REQUEST';
